import { render } from "./index.vue?vue&type=template&id=2540cd29&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2540cd29&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2540cd29"],['__file',"src/components/CropperImg/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2540cd29"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2540cd29', __exports__)) {
    api.reload('2540cd29', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2540cd29&scoped=true", () => {
    api.rerender('2540cd29', render)
  })

}


export default __exports__